import { Component, Input } from '@angular/core';
import { BannerTheme } from '../../Contract';

import styles from './VideoBanner.module.less';

const themeClass = {
	[BannerTheme.Bubble]: styles.bubble
};

@Component({
	selector: 'video-banner',
	templateUrl: './VideoBanner.Component.html',
	host: {
		'[class]': 'hostClass'
	},
	standalone: false
})
export class VideoBannerComponent {
	@Input() public name: string;
	@Input() public theme: BannerTheme;

	public readonly BannerTheme = BannerTheme;
	public readonly styles = styles;

	public get hostClass() {
		return styles.root + ' ' + (themeClass[this.theme] || '');
	}
}
